// @ts-strict-ignore
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { lastValueFrom, Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@fc-core';
import { getErrorMessage } from '@fc-core/services/notification.utils';
import { NotificationService } from '@fc-core/services/notification.service';
import { inject } from '@angular/core';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  isRefreshing = false;
  private notifications = inject(NotificationService);

  constructor(private auth: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    request = this.setTokenToRequest(request);

    return next
      .handle(request)
      .pipe(catchError((error) => this.checkResponseForErrors(error)));
  }

  private setTokenToRequest(request: HttpRequest<any>) {
    if (this.auth.token && !request.url.includes('api/auth/login')) {
      if (!request.headers.has('Authorization')) {
        request = request.clone({
          setHeaders: {
            Authorization: `JWT ${this.auth.token}`,
          },
        });
      }
    }

    return request;
  }

  private checkResponseForErrors(
    response: HttpResponse<any>,
  ): Observable<HttpEvent<any>> {
    if (response instanceof HttpErrorResponse) {
      if (environment?.debug) {
        this.notifications.showError(getErrorMessage(response));
      }
      if (
        response.url.search(environment.apiUrl) >= 0 &&
        response.status === 401 &&
        !response.url.includes('api/auth/token/refresh') &&
        !response.url.includes('api/auth/login')
      ) {
        if (this.isRefreshing) {
          return throwError(() => new Error('Token refresh in progress'));
        }
        this.isRefreshing = true;
        return new Observable((subscriber) => {
          this.handleUnauthorizedError().finally(() => {
            this.isRefreshing = false;
          });
          return subscriber.error(response);
        });
      }
    }
    return throwError(() => response);
  }

  private async handleUnauthorizedError() {
    try {
      const refreshedToken = await lastValueFrom(
        this.auth.refreshTokenRequest(),
      );
      if (refreshedToken) {
        location.reload();
      } else {
        this.auth.logoutWithoutRedirect();
        location.assign('/auth/login');
      }
    } catch {
      this.auth.logoutWithoutRedirect();
      location.assign('/auth/login');
    }
  }
}
